import {
  SupplierGetResponseType,
  SupplierStorefrontV2GetResponseType,
} from "@sellar-io/api-v2/types";
import { MinimumOrderPriceProgress } from "./components/MinimumOrderPriceProgress";
import { MinimumOrderQuantityProgress } from "./components/MinimumOrderQuantityProgress";

type OrderItem = {
  quantity: number;
  containerType: string | null;
  volume: number | null;
  unit: string | null;
  packQuantity: number | null;
};

export const PriceTierOrderRuleSummaryStorefront = ({
  priceTierOrderRules,
  minimumOrderPrice,
  hideWhenMet,
  hideIfNotApplicable,
  supplierStorefront,
  currency,
  orderItemList,
  orderTotal,
}: {
  minimumOrderPrice?: number | null;
  priceTierOrderRules?: SupplierGetResponseType["CustomerZones"][number]["PriceTier"]["PriceTierOrderRules"];
  hideWhenMet?: boolean;
  hideIfNotApplicable?: boolean;
  supplierStorefront: SupplierStorefrontV2GetResponseType | undefined;
  currency: SupplierGetResponseType["currency"];
  orderItemList: OrderItem[];
  orderTotal: number;
}) => {
  return (
    <div className={"flex flex-col gap-2"}>
      {minimumOrderPrice ? (
        <MinimumOrderPriceProgress
          minimumOrderPrice={minimumOrderPrice}
          price={orderTotal}
          currency={currency}
          hideWhenMet={hideWhenMet}
        />
      ) : null}
      {priceTierOrderRules?.map((rule, i) => (
        <MinimumOrderQuantityProgress
          key={i}
          orderItemList={orderItemList}
          rule={rule}
          hideWhenMet={hideWhenMet}
          hideIfNotApplicable={hideIfNotApplicable}
          caseSizeRuleList={supplierStorefront?.CaseSizeRules.list ?? []}
        />
      ))}
    </div>
  );
};
